import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  alignItems: 'center',
  padding: (p) => p.spacing(1.5),
  borderRadius: (p) => p.spacing(1),
  background: 'linear-gradient(to right, #F7F2FE 17.93%, #EBEFFE 95.46%)',
  maxWidth: (p) => p.spacing(150),
  width: '100%',
  mx: 'auto',
};

export const title: SxStyle = {
  background: `linear-gradient(to right, #3558B9 0%, #323232 100%)`,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
};

export const card: SxStyle = {
  padding: (p) => p.spacing(1.5),
  boxShadow: 'none',
  borderRadius: (p) => p.spacing(0.5),
  width: (p) => p.spacing(20.375),
  flex: '0 0 auto',
};

export const cardLabel: SxStyle = {
  letterSpacing: '-0.2px',
};

export const skeleton: SxStyle = {
  height: (p) => p.spacing(3.75),
  width: (p) => p.spacing(6),
};

export const videoTour: SxStyle = {
  width: '100%',
  height: (p) => p.spacing(12.875),
  display: 'flex',
  alignItems: 'stretch',
  textAlign: 'left',
  overflow: 'hidden',
  borderRadius: (p) => p.spacing(1),
  border: (p) => `1px solid ${p.palette.primary[300]}`,
  background: (p) => p.palette.common.white,
  cursor: 'pointer',
  p: 0,
};

export const videoTourIconBox: SxStyle = {
  width: (p) => p.spacing(7.25),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  background: (p) =>
    `linear-gradient(to bottom, ${p.palette.primary[600]} 0%, ${p.palette.primary[100]} 185%)`,
};

export const videoTourLabel: SxStyle = {
  letterSpacing: '-0.2px',
};
